module.exports = __webpack_public_path__ + "src/img/empty.d87a4ef4.png";